import type from './action-type';
import * as Api from 'api/api';
import { Input } from './reducer';
export const init = () => {
  return {
    type: type.INIT
  };
};

export const setInput = payload => {
  return {
    type: type.SET_INPUT,
    payload
  };
};

export const fetchInfo = callback => {
  return async f => {
    try {
      const { info } = await Api.userInfo();

      const { id, username, avatar, nickname, gender, birthday } = info;

      f(setInput({ [Input.id]: id }));
      f(setInput({ [Input.username]: username }));
      f(setInput({ [Input.nickname]: nickname }));
      f(setInput({ [Input.avatarUrl]: avatar }));
      f(setInput({ [Input.gender]: gender }));
      f(setInput({ [Input.birthday]: birthday }));

      if (callback) {
        callback();
      }
    } catch (error) {}
  };
};
